import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { Image } from '@yonderland/andes-react';
import { getImageFromCdn } from '../../util/ImageUtil';
const ALT_FALLBACK = 'content-lister-banner';
export const ContentListerBanner = ({ image }) => {
    const { imageCdnPrefix } = useAemConfig();
    const src = getImageFromCdn(image, imageCdnPrefix, '1680');
    return src ? _jsx(Image, { source: src, alt: image.alt || ALT_FALLBACK }) : null;
};
